import React from 'react';
import { closeModal, usePlayerUIContext } from '@24i/player-ui';
import useDimensions from '@24i/nxg-sdk-quantum/src/Dimensions/hooks/useDimensions';
import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';
import { useIsMobileLandscape } from '@24i/nxg-sdk-quantum/src/Dimensions/hooks/useIsMobileLandscape';
import { Button } from './styled';
import { PlayerIcon } from '../../../Icons';
export const CloseButton = ({ type, styles, testID = 'close_button', }) => {
    const { dispatch } = usePlayerUIContext();
    const { viewPortWidth } = useDimensions();
    const { isMobileLandscape } = useIsMobileLandscape();
    const iconSize = viewPortWidth < Breakpoint.SM || isMobileLandscape ? 24 : 48;
    const onClickHandler = () => {
        dispatch(closeModal(type));
    };
    return (React.createElement(Button, { testID: testID, onClick: onClickHandler, style: styles },
        React.createElement(PlayerIcon, { name: "onPrimary-close", style: { position: 'relative', width: iconSize, height: iconSize } })));
};
//# sourceMappingURL=index.js.map